<template>
  <div class="region_password_gate pos-f t0 l0 r0 b0 flex-ac jc-c" v-if="show" @touchmove.prevent>
    <img class="logo_img" src="/static/images/logo_1.png" alt="">
    <div class="gate_panel bg-f br8 pl20 pr20 pt30 pb30" @click.stop>
      <div class="f16 fw-b color-3 ta-c mb20">请选择地区并输入口令</div>
      <div class="f14 color-3 mb10">选择地区</div>
      <van-radio-group v-model="areaid" direction="horizontal" class="mb20">
        <van-radio
          class="mr15 mb10 f14"
          checked-color="#FC0324"
          v-for="item of area_list"
          :key="item.id"
          :name="String(item.id)"
        >
          {{ item.name }}
        </van-radio>
      </van-radio-group>
      <div class="f14 color-3 mb10">输入口令</div>
      <van-field
        class="gate_field mb20"
        v-model="word"
        clearable
        :border="false"
        placeholder="请输入口令"
        maxlength="30"
      />
      <van-button
        class="gate_submit w-100"
        type="danger"
        round
        block
        color="linear-gradient(90deg, #fc0324 0%, #ff144f 100%)"
        :loading="submitting"
        @click="submitHandle"
      >
        提交
      </van-button>
    </div>
    <div class="f12 color-c ta-c company_name">西安创客村电子商务有限责任公司</div>
  </div>
</template>

<script>
export default {
  name: 'regionPasswordGate',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    area_list: {
      type: Array,
      default: function () {
        return []
      }
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      areaid: '',
      word: ''
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.areaid = ''
        this.word = ''
      }
    }
  },
  methods: {
    submitHandle() {
      if (!this.areaid) {
        this.$toast('请选择地区')
        return
      }
      if (!this.word || !String(this.word).trim()) {
        this.$toast('请输入口令')
        return
      }
      this.$emit('submit', {
        areaid: this.areaid,
        word: String(this.word).trim()
      })
    }
  }
}
</script>

<style scoped lang="scss">
.region_password_gate {
  z-index: 2000;
  background: #FFF;
}
.gate_panel {
  width: 3.1rem;
  box-sizing: border-box;
  margin-top: -1rem;
}
.gate_field {
  padding: 0.08rem 0.12rem;
  background: #f7f8fa;
  border-radius: 0.08rem;
}
.gate_submit {
  height: 0.44rem;
  line-height: 0.44rem;
}
.company_name {
  position: fixed;
  bottom: 0.2rem;
  color: #999;
}
.logo_img {
  position: fixed;
  top: 0.2rem;
  width: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/components/regionPasswordGate.vue